import React, { useState } from 'react';
import MyPassengers from '../Components/MyPassengers';
import Header from '../Components/Header';

import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getCurrentUser } from '../redux/slices/userSlice';
import ProfileSection from '../Components/ProfileSection';
import AddressForm from '../Components/AddressForm';

const Sidebar = ({ setActiveSection, activeSection }) => {
    const dispatch = useDispatch();
    const { userInfo } = useSelector((state) => state.user);

    useEffect(() => {
        dispatch(getCurrentUser());
    }, [dispatch]);

    const profileImg = userInfo?.photo || 'https://images.unsplash.com/photo-1610106109549-5813ab87ae88?q=80&w=1974&auto=format&fit=crop';
    const name = userInfo?.name || 'user';
    const email = userInfo?.email || 'user@gmail.com';

    return (
        <div className="w-72 m-8 mr-0 bg-custom-white border-none max-h-screen-2xl rounded-xl shadow-md">
            <div className="p-4">
                <div className="flex flex-col items-center mb-6">
                    <img
                        src={profileImg}
                        alt="Profile"
                        className="w-40 h-40 rounded-full mr-3 object-cover"
                    />
                    <div className="text-center">
                        <h2 className="text-lg font-semibold pl-4 text-custom-blue">{name}</h2>
                        <p className="text-sm text-gray-400">{email}</p>
                    </div>
                </div>
                <ul className="space-y-2 text-xl">
                    <li>
                        <button
                            onClick={() => setActiveSection('profile')}
                            className={`flex items-center p-2 w-full text-left ${activeSection === 'profile'
                                ? 'text-custom-yellow border-l-4 mb-4 border-custom-yellow'
                                : 'text-gray-400 mb-4 hover:bg-gray-100'
                                }`}
                        >
                            <span className="mr-2">
                                <img src="/user-avatar.png" alt="User Avatar" className="w-5 h-5" />
                            </span>
                            My Profile
                        </button>
                    </li>
                    {/* <li>
                        <button
                            onClick={() => setActiveSection('booking')}
                            className={`flex items-center p-2 w-full text-left ${activeSection === 'booking'
                                ? 'text-custom-yellow border-l-4 mb-4 border-custom-yellow'
                                : 'text-gray-400 mb-4 hover:bg-gray-100'
                                }`}
                        >
                            <span className="mr-2">
                                <img src="/event.png" alt="Booking Icon" className="w-6 h-6" />
                            </span>
                            My Booking
                        </button>
                    </li> */}
                    {/* <li>
                        <button
                            onClick={() => setActiveSection('quotation')}
                            className={`flex items-center p-2 w-full text-left ${activeSection === 'quotation'
                                ? 'text-custom-yellow border-l-4 mb-4 border-custom-yellow'
                                : 'text-gray-400 mb-4 hover:bg-gray-100'
                                }`}
                        >
                            <span className="mr-2">
                                <img src="/wallet.png" alt="Quotation Icon" className="w-5 h-5" />
                            </span>
                            My Quotation
                        </button>
                    </li> */}
                    <li>
                        <button
                            onClick={() => setActiveSection('passengers')}
                            className={`flex items-center p-2 w-full text-left ${activeSection === 'passengers'
                                ? 'text-custom-yellow border-l-4 mb-4 border-custom-yellow'
                                : 'text-gray-400 mb-4 hover:bg-gray-100'
                                }`}
                        >
                            <span className="mr-2">
                                <img src="/group.png" alt="Group Icon" className="w-5 h-5" />
                            </span>
                            My Passengers
                        </button>
                    </li>
                </ul>
            </div>
        </div>
    );
};


const MyBookings = () => {
    return (
        <div className="p-6">
            <div className="flex items-center justify-center">
                <div className="flex items-center space-x-6 max-w-3xl w-full px-4">
                    <img
                        src="/mybooking.png"
                        alt="No bookings"
                        className="w-52 h-52 lg:w-40 lg:h-40 opacity-30"
                    />
                    <p className="text-xl text-gray-400 font-semibold">
                        Seems you don’t have any bookings yet
                    </p>
                </div>
            </div>
        </div>
    );
};

const UserDashboard = () => {
    const [activeSection, setActiveSection] = useState('profile');

    const renderContent = () => {
        switch (activeSection) {
            case 'profile':
                return (
                    <>
                        <ProfileSection />
                        <AddressForm />
                    </>
                );
            case 'passengers':
                return <MyPassengers />;
            case 'booking':
                return <MyBookings />;
            case 'quotation':
                return (
                    <div className="bg-custom-white p-6 rounded-lg border-2 shadow-md">
                        <h2 className="text-xl font-semibold text-custom-blue">My Quotation</h2>
                        <p className="text-gray-400">No quotations available.</p>
                    </div>
                );
            default:
                return null;
        }
    };

    return (
        <div className="w-full px-4 sm:px-6 lg:px-16 xl:px-24 py-8 max-w-screen-2xl pt-2 mx-auto">
            <Header />
            <div className="flex max-w-screen-2xl">
                <Sidebar setActiveSection={setActiveSection} activeSection={activeSection} />
                <div className="flex-1 p-8">{renderContent()}</div>
            </div>
        </div>
    );
};

export default UserDashboard;